import { saveLocalData, getLocalData, removeLocalData } from '@/lib/base/localData';

/**
 * 改密碼「發送驗證碼／重新發送驗證碼」的前端冷卻倒數。
 * 存在 localStorage，讓使用者重新整理頁面也無法立即再打一次 requestPasswordReset。
 */
const STORAGE_KEY = 'pwdResetOtpCooldown';
const OTP_RESEND_COOLDOWN_SECONDS = 60;

function readOtpCooldown() {
  const raw = getLocalData(STORAGE_KEY);
  if (!raw) return null;
  let parsed;
  try {
    parsed = JSON.parse(raw);
  } catch (e) {
    removeLocalData(STORAGE_KEY);
    return null;
  }
  const { email, until } = parsed || {};
  const remain = Math.ceil((until - Date.now()) / 1000);
  if (!email || !remain || remain <= 0) {
    removeLocalData(STORAGE_KEY);
    return null;
  }
  return { email, remain };
}

function writeOtpCooldown(email, seconds = OTP_RESEND_COOLDOWN_SECONDS) {
  saveLocalData(STORAGE_KEY, { email, until: Date.now() + seconds * 1000 });
}

function clearOtpCooldown() {
  removeLocalData(STORAGE_KEY);
}

export { readOtpCooldown, writeOtpCooldown, clearOtpCooldown, OTP_RESEND_COOLDOWN_SECONDS };
